// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"cdab1c0d","104":"a7eed387","146":"0c59cb00","444":"5b22f5e9","453":"18628dc1","650":"a88bc9ad","706":"4ff0bf64","716":"85f83da9","910":"0c4191c4"}[chunkId] + ".chunk.js";
};